<template>
  <div id="introduction">
    <div class="card shadow mb-4">
      <div class="card-header bg-transparent">
        <div class="row align-items-center">
          <div class="col">
            <h6 class="text-uppercase text-muted ls-1 mb-1">Tackling Blight</h6>
            <h2 class="mb-0">Featured Rehab</h2>
          </div>
        </div>
      </div>
      <div class="card-body">
        <image-compare :before="afterImage" :after="beforeImage" class="mb-4">
          <i class="fa fa-angle-left" aria-hidden="true" slot="icon-left"></i>
          <i class="fa fa-angle-right" aria-hidden="true" slot="icon-right"></i>
        </image-compare>
<p>This Jamestown
home was
acquired as a
bank foreclosure
in 2018 by the
Land Bank. It had
been vacant for
several years. The purchasers
completed an
upscale
renovation with a
modern open
floor plan and
upgraded
appointments. The home is
currently on the
market and
represents the
fourth home on
this street that
benefited by the
Land Bank’s
intervention.
</p>
      </div><!-- /.card-body -->
    </div><!-- /.card -->

<!-- STATS SECTION -->
<!--
<div class="row mb-4">
  <div class="col-md-3 pr-0">
    <div class="card card-stats mt-2 mb-4 mb-xl-0">
      <div class="card-body">
        <div class="row">
          <div class="col">
            <h5 class="card-title text-uppercase text-muted mb-0">Jamestown Demos</h5>
            <span class="h4 mb-0">Goal: 30</span><br>
            <span class="h4 mb-0">Demolished: 59</span>
          </div>
          <div class="col-auto">
            <div class="icon icon-shape bg-success text-white rounded-circle shadow">
              <i class="fas fa-chart-bar"></i>
            </div>
          </div>
        </div>
        <p class="mt-3 mb-0 text-muted text-sm">
          <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 197%</span>
          <span class="text-nowrap">Achievement Rate</span>
        </p>
      </div>
    </div>
  </div>
  <div class="col-md-3 pr-0">
    <div class="card card-stats mt-2 mb-4 mb-xl-0">
      <div class="card-body">
        <div class="row">
          <div class="col">
            <h5 class="card-title text-uppercase text-muted mb-0">Dunkirk Demos</h5>
            <span class="h4 font-weight-bold mb-0">Goal: 15</span><br>
            <span class="h4 font-weight-bold mb-0">Demolished: 10</span>
          </div>
          <div class="col-auto">
            <div class="icon icon-shape bg-danger text-white rounded-circle shadow">
              <i class="fas fa-chart-bar"></i>
            </div>
          </div>
        </div>
        <p class="mt-3 mb-0 text-muted text-sm">
          <span class="text-danger mr-2"><i class="fas fa-arrow-down"></i> 67%</span>
          <span class="text-nowrap">Achievement Rate</span>
        </p>
      </div>
    </div>
  </div>
  <div class="col-md-3 pr-0">
    <div class="card card-stats mt-2 mb-4 mb-xl-0">
      <div class="card-body">
        <div class="row">
          <div class="col">
            <h5 class="card-title text-uppercase text-muted mb-0">Rural Demos</h5>
            <span class="h4 font-weight-bold mb-0">Goal: 9</span><br>
            <span class="h4 font-weight-bold mb-0">Demolished: 13</span>
          </div>
          <div class="col-auto">
            <div class="icon icon-shape bg-success text-white rounded-circle shadow">
              <i class="fas fa-chart-bar"></i>
            </div>
          </div>
        </div>
        <p class="mt-3 mb-0 text-muted text-sm">
          <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 145%</span>
          <span class="text-nowrap">Achievement Rate</span>
        </p>
      </div>
    </div>
  </div>
  <div class="col-md-3 pr-0">
    <div class="card card-stats mt-2 mb-4 mb-xl-0">
      <div class="card-body">
        <div class="row">
          <div class="col">
            <h5 class="card-title text-uppercase text-muted mb-0">Mixed-Use Demos</h5>
            <span class="h4 font-weight-bold mb-0">Goal: 7</span><br>
            <span class="h4 font-weight-bold mb-0">Demolished: 8</span>
          </div>
          <div class="col-auto">
            <div class="icon icon-shape bg-success text-white rounded-circle shadow">
              <i class="fas fa-chart-bar"></i>
            </div>
          </div>
        </div>
        <p class="mt-3 mb-0 text-muted text-sm">
          <span class="text-success mr-2"><i class="fas fa-arrow-up"></i> 114%</span>
          <span class="text-nowrap">Achievement Rate</span>
        </p>
      </div>
    </div>
  </div>
</div><!-- /.row -->
<!-- END STATS SECTION -->

    <div class="row">
      <!-- Letter from the Director -->
      <div class="col-md-8">
        <div class="card shadow">
          <div class="card-header bg-transparent">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="text-uppercase text-muted ls-1 mb-1">Letter from the Director</h6>
                <h2 class="mb-0">Gina Paradis</h2>
              </div>
            </div>
          </div>
          <div class="card-body">
<h3>This Place We Call Home</h3>
<p>“Home” is place where we live, where our family shares our life experience, where we hope to find rest, refuge, love,
safety and nourishment. In some neighborhoods and in some families, this reflects the achievement of a fulfilling life, to
others, an aspiration, and to yet others a vision that is frustratingly out of grasp. Everyone deserves a home. Everyone
deserves a safe neighborhood. </p>
<p>At the Chautauqua County Land Bank, we endeavor to turn vacant properties in disrepair into safe and healthy homes.
We endeavor to make neighborhoods safer, more attractive, and more resilient. Although small in capacity, our
organization takes on this challenge “one house at a time”, as I always say. We’ve had a fair bit of success. Securing over
$5.5 million in grant funding since 2013, we have helped communities throughout the county with lingering issues of
blighted abandoned property, demolishing over 150 unsafe structures and finding
purchasers who are willing to turn 145 dilapidated
properties into safe and attractive homes. We have learned
to cluster our investments to maximize impacts in city
neighborhoods, and focus our rural activities on Main
Streets, to improve the overall perception of the
community.</p>
<h3>Persistence to Resilience</h3>
<p>2019 proved to be a challenging year for the Chautauqua County Land Bank Corporation. The tax foreclosure auction
was flooded with sub-standard properties abandoned in bulk by several property owners in the county. With limited
acquisition options to bolster our rehab inventory, our focus shifted to demolition and working with municipalities to
trouble-shoot long-standing problem properties to support safer neighborhoods and economic development. Creative
problem solving and collaboration are key to rebuilding local economies and strengthening neighborhoods. Thinking
beyond the bricks and morter improvements that the land bank can affect, we sought to leverage our funding and skill
sets with those of other programs, to build a more strategic and comprehensive approach to housing issues across the
county.</p>
<p>Significant time was dedicated to developing new initiatives and partnerships, which will continue into 2020. Chief
among them is the Healthy Housing Task Force, a coalition of housing partners and stakeholders committed to
improving housing standards and decreasing the numbers of lead poisoned children throughout the county, particularly
in the city of Jamestown. A portion of our funding was directed to tackle issues with lead abatement, as the Land Bank
plans to take an active role in creating safer,
LETTER FROM THE EXECUTIVE DIRECTOR
healthier neighborhoods and housing stock in Chautauqua County. According to the county
Health Department, “the New York State Department of Health (NYSDOH) data shows
Chautauqua County as having among the highest rates of lead poisoned children in New
York State. The County’s old housing stock and the numbers of properties in poor condition
are largely to blame.” Exposure can lead to a myriad of mental and behavioral problems in
children, and lead poisoning creates irreversible damage in children. Only 1 in 3 children in
the county are tested, and high levels of exposure are most common in low income
populations. Yet lead poisoning is 100% preventable. The Chautauqua County Land Bank is
dedicating funding and efforts to help tackle this safe housing issue at the property and the
community level.</p>
<p>Additional partnerships are being cultivated in workforce
development for the construction trades, in economic development
initiatives, and neighborhood safety and security. 2019 was a year of
coalition building, and these new partnerships will create a synergy that will drive progress in our county’s housing
outlook.</p>
<p>Our investments focused on the hardest hit cities of Jamestown and Dunkirk, where our efforts continue to center on
stabilizing transitional neighborhoods, and addressing safety and health hazards in the most distressed neighborhoods.
Increased funding was also dedicated to the rural communities, and this will continue through 2020.</p>
<h3>Partnerships & Collaborations</h3>
<p>It was an honor and pleasure to work with the following partners to seek creative solutions to our county’s housing and
community development challenges: Healthy Housing Coalition, Unite No. Main (Jamestown), Chautauqua County
Partnership for Growth, Habitat for Humanity, Chautauqua Opportunities Inc., Chautauqua Housing Rehab and
Improvement Corporation, and Southern Tier Environments for Living, the Cities of Jamestown and Dunkirk
Departments of Development and Code Enforcement. </p>
<p>We wish to thank all of our partners, including Enterprise Community Partners, Inc., the New York State Attorney
General’s office, the Chautauqua County Legislature, our local municipal leaders, county and local housing champions,
vendors, and all of those individuals who have supported our efforts through their purchases, services, partnerships, and
voices. </p>
<p>Sharing our mission, expanding our reach, engaging more stakeholders as we tackle the issues of blight in Chautauqua
County will continue to be our focus in 2020. As we develop new programs borne out of our 2019 collaborations, we will
strive to expand our reach and inclusivity. We hope you will join us in helping to make our neighborhoods safe and
strong, and providing healthy housing opportunities for all. Let’s work together to transform more houses into homes.</p>

            <p>Sincerely,</p>
            <p class="lead">Gina Paradis</p>

          </div>
        </div>
      </div><!-- /.col-md-8 -->
      <div class="col-md-4">
        <div class="card shadow">
          <div class="card-body">
            <img width="100%" src="https://firebasestorage.googleapis.com/v0/b/cclbc-annual-report-2018.appspot.com/o/images%2FGina%20Color%201.jpg?alt=media&token=808a8a64-c935-4c2a-b65b-1dd1b4c657a2">
          </div><!-- /.card-body -->
        </div><!-- /.card .shadow -->

    </div>
    </div><!-- /.row -->
  </div><!-- /#Introduction -->
</template>

<script>
export default {
  data() {
    return {
      beforeImage: '/static/before_after/before.jpg',
      afterImage: '/static/before_after/after.jpg'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Introduction.vue